import { render, staticRenderFns } from "./Genius_Brain.vue?vue&type=template&id=eadc0fac&scoped=true&"
import script from "./Genius_Brain.vue?vue&type=script&lang=js&"
export * from "./Genius_Brain.vue?vue&type=script&lang=js&"
import style0 from "./Genius_Brain.vue?vue&type=style&index=0&id=eadc0fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadc0fac",
  null
  
)

export default component.exports